import {Button, ButtonProps} from "@mantine/core";

function ButtonFillFormTest(props:ButtonProps<any>){

    if (process.env.REACT_APP_ALLOW_TEST_FILL_FORM !== "true"){
        return null;
    }

    return (
        <Button {...props}>

        </Button>
    )

}

export default ButtonFillFormTest;